import React from "react";
import styled from "styled-components";
import * as icons from "../../icon-components";
import { includeStyledSystem, sx } from "../../util/styledSystem";
const getVariants = ({ colors: { iconColors } }) => ({
    avatar: {
        color: iconColors.avatar,
    },
    avatarQuaternary: {
        color: iconColors.avatarQuaternary,
    },
    avatarSecondary: {
        color: iconColors.avatarSecondary,
    },
    avatarTertiary: {
        color: iconColors.avatarTertiary,
    },
    button: {
        color: iconColors.button,
    },
    danger: {
        color: iconColors.danger,
    },
    disabled: {
        color: iconColors.disabled,
    },
    grey: {
        color: iconColors.grey,
    },
    info: {
        color: iconColors.info,
    },
    infoDark: {
        color: iconColors.infoDark,
    },
    inherit: {
        color: "inherit",
    },
    primary: {
        color: iconColors.primary,
    },
    secondary: {
        color: iconColors.secondary,
    },
    sidebar: {
        color: iconColors.sidebar,
    },
    success: {
        color: iconColors.success,
    },
    tertiary: {
        color: iconColors.tertiary,
    },
    textColor: {
        color: iconColors.textColor,
    },
    tooltipQ: {
        color: iconColors.tooltipQ,
    },
    warningDark: {
        color: iconColors.warningDark,
    },
    warningLight: {
        color: iconColors.warningLight,
    },
    white: {
        color: iconColors.white,
    },
});
const DEFAULT_VARIANT = "inherit";
// Line height dictates automatic box height, therefore, if line height is larger than icon size,
// It will add space above the icon, which is unwanted, therefore,
// we are setting the height of the line of text as null.
const StyledSpan = styled.span `
  ${({ theme, variant = DEFAULT_VARIANT }) => (Object.assign(Object.assign({}, getVariants(theme)[variant]), { lineHeight: 0 }))};
  ${includeStyledSystem()}
  ${sx}
`;
/**
 * Icon component will render an SVG component imported from the icons library in the icon-components folder.
 * Using this will ensure the proper size and aria attributes are added.
 * @param IconWithVariantProps
 * @returns an svg icon loaded as a React component
 */
export const IconWithVariant = ({ variant = DEFAULT_VARIANT, "data-testid": testId = "iconWithVariant", src, size = "24px", wrapperProps, }) => {
    // eslint-disable-next-line import/namespace
    let SourceComponent = icons[src];
    if (!SourceComponent) {
        SourceComponent = icons.CheckBoxOutline;
    }
    return (React.createElement(StyledSpan, { variant: variant, sx: Object.assign({}, wrapperProps) },
        React.createElement(SourceComponent, { "data-testid": testId, "data-icon-name": src, height: size, style: { height: size, margin: "0", width: size }, width: size })));
};
